import { Service } from "../../config/service";

class TabelaPitom extends Service {

    constructor() {
        super("tabela-pitom")
    }

    async getPrice(params, config = {}) {
        try {
            const response = await this.http84.get(`${this.getResource().get}${params}`, { params: this.getParams(), ...config })
            return Promise.resolve(response)
        } catch (e) {
            this.setError(e)
            return Promise.reject(this.getError())
        }
    }

}

export default TabelaPitom